import { j as r } from "../jsx-runtime-ClSzPYp4.js";
import { s as e } from "../index.esm-DOxVcNnO.js";
import { styled as t } from "styled-components";
import { color as i } from "styled-system";
import "../colors-C72eWVhK.js";
import { SCREEN_WIDTHS as s } from "../common/themes/constants/constants.mjs";
const m = /* @__PURE__ */ t.header.withConfig({
  shouldForwardProp: (o) => e(o)
}).withConfig({
  componentId: "sc-57582bc5-0"
})([
  "",
  ";",
  ";"
], ({ theme: o }) => o.components.header.base, i), c = /* @__PURE__ */ t.div.withConfig({
  shouldForwardProp: (o) => e(o)
}).withConfig({
  componentId: "sc-57582bc5-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.header.container), u = ({ bordered: o, maxWidth: d = s.EIGHT_COLUMN, children: a, ...n }) => /* @__PURE__ */ r.jsx(m, {
  "data-qa-id": "header",
  ...n,
  children: /* @__PURE__ */ r.jsx(c, {
    "data-qa-id": "header-container",
    bordered: o,
    maxWidth: d,
    children: a
  })
});
export {
  u as default
};
